import { styled } from '@mui/material';
import { ContentWrapper } from '../../../styles/shared';

export const OuterWrapper = styled(ContentWrapper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  width: '100%',
  position: 'relative',
  gap: theme.spacings.unit(19.5),
  marginBottom: theme.spacings.unit(24),
  [theme.breakpointsMediaQuery.down('md')]: {
    flexDirection: 'column',
    marginBottom: theme.spacings.unit(14),
  },
}));

export const ContentLeft = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  width: '50%',
  [theme.breakpointsMediaQuery.down('md')]: {
    width: '100%',
  },
}));

export const ContentRight = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  width: '50%',
  gap: theme.spacings.unit(18),
  [theme.breakpointsMediaQuery.down('md')]: {
    width: '100%',
  },
}));

export const StickyDiv = styled('div')(({ theme, shouldBeSticky }) => ({
  position: 'sticky',
  top: theme.spacings.unit(38),
  zIndex: !shouldBeSticky ? 3000 : '',
}));
